import { Shield, Lock, FileCheck, Server, Users, Activity } from "lucide-react";
import { motion } from "framer-motion";

const items = [
    { icon: Shield, t: "ISO 27001 Ready", d: "Controls aligned to ISO 27001, SOC 2 and enterprise governance standards." },
    { icon: Lock, t: "End-to-End Encryption", d: "AES-256 at rest, TLS 1.3 in transit. Zero-trust request validation." },
    { icon: FileCheck, t: "Immutable Audit Trail", d: "Every action cryptographically logged and tamper-evident." },
    { icon: Server, t: "Deployment Choice", d: "Cloud, Private Cloud or Air-gapped on-premises deployments." },
    { icon: Users, t: "RBAC & SSO", d: "Role-based access, OIDC/OAuth2, SAML, LDAP and Active Directory." },
    { icon: Activity, t: "24/7 Observability", d: "Proactive monitoring with SLA-backed incident response." },
];

export default function Security() {
    return (
        <section data-testid="security-section" className="bg-white">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-36">
                <div className="grid lg:grid-cols-12 gap-8 mb-16">
                    <div className="lg:col-span-6">
                        <div className="eyebrow">Enterprise Readiness</div>
                        <h2 className="headline text-4xl md:text-5xl lg:text-6xl mt-4 text-navy">
                            Security built for <br /> critical operations.
                        </h2>
                    </div>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {items.map((it, i) => (
                        <motion.div
                            key={it.t}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                            className="bg-[#F7F9FC] border border-slate-200 rounded-2xl p-8"
                        >
                            <div className="w-11 h-11 rounded-full bg-navy text-[#E8B923] flex items-center justify-center mb-6">
                                <it.icon className="w-5 h-5" />
                            </div>
                            <h3 className="font-serif text-xl text-navy">{it.t}</h3>
                            <p className="text-slate-600 text-sm mt-3 leading-relaxed">{it.d}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
